import { inject, Injectable } from "@angular/core";
import { CardBinder } from "@models/binder.model";
import { Card } from "@models/card.model";
import { Api } from "@services/api.service";

@Injectable({
	providedIn: 'root'
})
export class StatService{
	private readonly api=inject(Api);

	getCardSetStats(type: string){
		return this.api.get<StatCardSet>(`/my-stats/${type}/card-sets`);
	}

	getDetailStats(type: string){
		return this.api.get<StatDetailType>(`/my-stats/${type}/details`);
	}
}

export interface StatCardSet{
	cardSet: string;
	nb: number;
}

export interface StatDetailType{
	cards: number;
	unique: number;
	value: number;
	totalType: number;
	top10: CardBinder[];
	topRef: Card[];
	rarities: Stat[];
	variantes: Stat[];
	conditions: Stat[];
}

interface Stat{
	name: string;
	nb: number;
}